import React from "react";
// import { useParams } from "react-router-dom";
import ActionCenterModal from "./modals/ActionCenterModal";
import RecordsTable from "./modals/RecordsTable";

const UserBusinessHub = () => {
    return (
        <div style={{ padding: "10px" }}>
            <ActionCenterModal />
            <br />
            <RecordsTable />
        </div>
    );
};

export default UserBusinessHub;
